

































import { Component, Vue, Prop } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';

@Component({
  components: {
    Datepicker,
  },
})
export default class BaseDatepicker extends Vue {
  @Prop({ type: [String, Date], required: true }) private value!: string | number;
  @Prop({ type: String, required: false, default: '' }) private name!: string;
  @Prop({ type: Boolean, required: false, default: false }) private focus!: boolean;
  @Prop({ type: String, required: false, default: '' }) private placeholder!: string;
  /* tslint:disable-next-line */
  @Prop({ type: Object, required: false, default: () => {} }) private validation!: object;
  @Prop({ type: Array, required: false, default: () => [] }) private validations!: [object];

  private setFocus(field: string): void {
    if (this.name === field) {
      (this.$refs[this.name] as HTMLElement).focus();
    }
  }

  private mounted(): void {
    if (this.focus) {
      (this.$refs[this.name] as HTMLElement).focus();
    }
  }

  private onDateChange(date: Date): void {
    this.$emit('input', date.toDateString());
  }
}
